import { createFileRoute } from '@tanstack/react-router';
import { motion } from 'framer-motion';
import { PerformanceMetrics } from '@/components/PerformanceMetrics';
import { PnlCalendarHeatmap } from '@/components/PnlCalendarHeatmap';
import { RiskOfRuinCard } from '@/components/RiskOfRuinCard';
import { TradeFrequencyChart } from '@/components/TradeFrequencyChart';
import { HoldingPeriods } from '@/components/HoldingPeriods';
import { SetupBuckets } from '@/components/SetupBuckets';
import { MistakeCounts } from '@/components/MistakeCounts';
import { PositionSizer } from '@/components/PositionSizer';
import { TiltBanner } from '@/components/TiltBanner';

export const Route = createFileRoute('/performance')({
  component: PerformancePage,
});

function PerformancePage() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 6 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.25, ease: [0.16, 1, 0.3, 1] }}
      className="space-y-4"
    >
      <div>
        <h1 className="text-xl font-semibold text-zinc-100 tracking-tight">Performance</h1>
        <p className="text-[12px] text-zinc-400 mt-0.5">
          Returns, risk, edge, and the discipline ledger. Time-weighted return
          is trading skill; money-weighted is wallet reality.
        </p>
      </div>

      <TiltBanner />
      <PerformanceMetrics />
      <RiskOfRuinCard />

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        <div className="lg:col-span-2">
          <PnlCalendarHeatmap />
        </div>
        <PositionSizer />
      </div>

      <TradeFrequencyChart />
      <HoldingPeriods />
      <SetupBuckets />
      <MistakeCounts />
    </motion.div>
  );
}
